import { Visibility, VisibilityOff } from "@mui/icons-material"
import { IconButton, InputAdornment, TextField, type TextFieldProps } from "@mui/material"
import type { FC } from "react"
import { useState } from "react"

type PasswordTextFieldProps = Omit<TextFieldProps, 'type' | 'InputProps'> & {
  showVisibilityToggle?: boolean
}

/**
 * パスワード入力フィールドコンポーネント
 * 表示/非表示の切り替えボタン付き
 */
export const PasswordTextField: FC<PasswordTextFieldProps> = ({
  showVisibilityToggle = true,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false)

  const handleToggleVisibility = () => {
    setShowPassword(!showPassword)
  }

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
  }

  return (
    <TextField
      {...props}
      type={showPassword ? "text" : "password"}
      InputProps={{
        endAdornment: showVisibilityToggle ? (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleToggleVisibility}
              onMouseDown={handleMouseDownPassword}
              edge="end"
              size="small"
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ) : undefined,
      }}
    />
  )
}